import React, { useEffect, useState } from "react";
import { FcGoogle } from "react-icons/fc";
import { Button } from '@mui/material';
import { useModal } from "../../contexts/ModalContext";
import { REDIRECT_FE_URLS } from '../../utils/Constants';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useLoader } from "../../contexts/LoaderContext";
import api from "../../services/api";

const GoogleOAuthButton = ({ action }) => {
  const [error, setError] = useState(null);
  const { oauthLogin } = useAuth();
  const { showLoader, hideLoader } = useLoader();
  const { openSuccessModal, openErrorModal, closeModal } = useModal();
  const navigate = useNavigate();

  const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  const GOOGLE_REDIRECT_URL = process.env.REACT_APP_GOOGLE_REDIRECT_URL;
  const GOOGLE_AUTH_URL = `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${GOOGLE_CLIENT_ID}&redirect_uri=${GOOGLE_REDIRECT_URL}&scope=openid%20email%20profile&access_type=offline`;

  const [codeProcessed, setCodeProcessed] = useState(false);

  const handleOAuthClick = () => {
    window.location.href = GOOGLE_AUTH_URL;
  };

  const handleGoogleAuth = async (authorizationCode) => {
    showLoader();

    try {
      const tokenResponse = await api.post('exchangetoken/', { authorization_code: authorizationCode });
      const { id_token } = tokenResponse.data;
      
      if (!id_token) {
        throw new Error('Failed to get id_token from backend');
      }

      const signupResponse = await api.post('oauth/signup/', { google_id_token: id_token });
      const result = signupResponse.data;

      api.setAuthToken(result.access_token);
      console.log(result, REDIRECT_FE_URLS, REDIRECT_FE_URLS[result.redirect_url]);
      hideLoader();

      if (result.redirect_url === 'account_status') {
        if(result.user_exist) {
          navigate("/auth/account-status/" + result.account_id)
        } else {
          openSuccessModal(
            "Sign Up Successful",
            "Your account has been created and is under review. You will receive an email once your account is verified."
          );
        }
      } else if (result.redirect_url === 'complete_onboarding') {
        navigate(REDIRECT_FE_URLS[result.redirect_url]);
      } else {
        showLoader("Logging in...");
        return oauthLogin(result.user, result.access_token)
          .then(() => {
              hideLoader();
              navigate(REDIRECT_FE_URLS[result.redirect_url]);
        });
      }
    } catch (error) {
      hideLoader();
      openErrorModal("Sign Up Failed", error.message || "Something went wrong.");
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const authorizationCode = urlParams.get("code");

    if (authorizationCode && !codeProcessed) {
      setCodeProcessed(true);
      
      // Clear the "code" parameter from the URL
      const url = new URL(window.location.href);
      url.searchParams.delete("code");
      window.history.replaceState({}, document.title, url.toString());

      handleGoogleAuth(authorizationCode);
    }
  }, [codeProcessed]);

  return (
    <Button
      fullWidth
      variant="outlined"
      startIcon={<FcGoogle />}
      onClick={handleOAuthClick}
      className="oauth-button google-button"
      sx={{
        minHeight: 50,
        py: 1.25,
        borderRadius: '8px',
        fontSize: '1rem',
        fontWeight: 600,
        textTransform: 'none',
        color: '#1f2937',
        backgroundColor: '#fff',
        border: '1px solid',
        borderColor: '#e0e0e0',
        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
        '&:hover': {
          backgroundColor: '#f8fafc',
          borderColor: '#bdbdbd',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        },
      }}
    >
      {action === "signup" ? "Sign up with Google" : "Login with Google"}
    </Button>
  );
};

export default GoogleOAuthButton;